export const isValidUrl = (url: unknown): boolean => {
    try {
        return Boolean(new URL(String(url)));
    } catch {
        return false;
    }
};
